import React from 'react';
import './LoadingState.css';

export default function LoadingState({ message = 'Loading...', fullscreen = false }) {
  return (
    <div className={`loading-state ${fullscreen ? 'loading-state--fullscreen' : ''}`} role="status" aria-live="polite">
      <div className="loading-spinner" aria-hidden="true" />
      <p className="loading-message">{message}</p>
    </div>
  );
}
